import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '../../shared/guards/auth.guards';
import { Groups } from '../security/model/groups.model';
import { SurveyFormSubmissionComponent } from './components/survey-form-submission/survey-form-submission.component';
export class SurveyManagementRoutingStates {
  public static readonly LIST = {
    url: 'surveymanagement/:formId/formsubmissions/:formName'
  };
}

export const UserRoutes: Routes = [
  {
    path: SurveyManagementRoutingStates.LIST.url,
    data: {
      page: {
        title: 'Survey Management'
      },
      requiresRole: [Groups.FORMS_ADMINISTRATOR]
    },
    component: SurveyFormSubmissionComponent,
    canActivate: [AuthGuard]
  }
];

@NgModule({
  exports: [RouterModule],
  imports: [RouterModule.forChild(UserRoutes)]
})
export class SurveyManagementRoutingModule {}
